import "./App.scss";
import {
  EnumerationProvider,
  FormProvider,
  GlobalProvider,
  ToastProvider,
} from "@techsharegov/react-ui";
import { Layout } from "./Layout";
import { Route, Switch } from "react-router-dom";
import { useGetRoutes } from "Navigation";
import { PUBLIC_PORTAL_API_PREFIX } from "Constants";
import { Meetings } from "Features/Meetings";

function App() {
  var configObj =
    process.env.NODE_ENV === "development"
      ? {
          baseUrl:
            (process.env.REACT_APP_BASE_URL || "localhost:3001") +
            PUBLIC_PORTAL_API_PREFIX,
          apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
          environmentName: process.env.REACT_APP_ENVIRONMENT_NAME,
          versionNumber: "0.0.0.0",
          noAuth: true,
        }
      : {
          baseUrl: window.BASE_URL + PUBLIC_PORTAL_API_PREFIX,
          apiEndpoint: window.API_ENDPOINT,
          versionNumber: window.VERSION_NUMBER,
          environmentName: window.ENVIRONMENT_NAME,
          noAuth: true,
        };

  return (
    <GlobalProvider {...configObj}>
      <AppContent />
    </GlobalProvider>
  );
}

const AppContent: React.FC = () => {
  const routes = useGetRoutes();

  return (
    <Layout>
      <ToastProvider>
        <EnumerationProvider>
          <FormProvider>
            <Switch>
              {routes}
              <Route path="/*" component={Meetings} />
            </Switch>
          </FormProvider>
        </EnumerationProvider>
      </ToastProvider>
    </Layout>
  );
};

export default App;
